/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemUserDetectionFeedbackHideDetectionFromJSON(json) {
    return WallItemUserDetectionFeedbackHideDetectionFromJSONTyped(json, false);
}
export function WallItemUserDetectionFeedbackHideDetectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'detectionId': !exists(json, 'detection_id') ? undefined : json['detection_id'],
    };
}
export function WallItemUserDetectionFeedbackHideDetectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'detection_id': value.detectionId,
    };
}
//# sourceMappingURL=WallItemUserDetectionFeedbackHideDetection.js.map